import { sendAnalytics } from '@/services/analyticsService';
import { getUserEmail } from '@/services/authentication';
import { format } from 'date-fns';
import domToImage from 'dom-to-image';
import FileSaver from 'file-saver';
import type { ReportUserPeriod } from '../@types/types';
import type { UserProps } from '../hooks/useUserData';

type ExportAsPngProps = {
	container: HTMLDivElement | null;
	reportUserPeriod: ReportUserPeriod;
	user: UserProps;
};

const getListName = (reportUserPeriod: ReportUserPeriod) => {
	if (!reportUserPeriod.listId) {
		return 'Overall';
	}

	return reportUserPeriod.listName;
};

export const handleExportAsPng = async ({
	container,
	reportUserPeriod,
	user
}: ExportAsPngProps) => {
	const scale = 2;

	if (container) {
		FileSaver.saveAs(
			await domToImage.toPng(container as Node, {
				width: container.clientWidth * scale,
				height: container.clientHeight * scale,
				style: {
					transform: `scale(${scale}) translate(${
						container.offsetWidth / 2 / scale
					}px, ${container.offsetHeight / 2 / scale}px)`,
					width: `${container.offsetWidth}px`,
					height: `${container.offsetHeight}px`
				},
				bgcolor: '#424242'
			}),
			`${
				reportUserPeriod?.userEmail || getUserEmail()
			} List [${getListName(reportUserPeriod)}] report ${format(
				reportUserPeriod.startDate,
				'MMM d, y'
			)} - ${format(reportUserPeriod.endDate, 'MMM d, y')}.png`
		);
		if (user && user.email) {
			sendAnalytics({
				type: 'track',
				userId: user.email,
				eventName: 'User exported Activity Report',
				properties: {
					exportType: '.png',
					listName: reportUserPeriod?.listName,
					listId: reportUserPeriod?.listId,
					userEmail: reportUserPeriod?.userEmail,
					startDate: format(reportUserPeriod.startDate, 'MMM d, y'),
					endDate: format(reportUserPeriod.endDate, 'MMM d, y')
				}
			});
		}
	} else if (container == null) {
		if (user && user.email) {
			sendAnalytics({
				type: 'track',
				userId: user.email,
				eventName:
					'user tried to export activity report as .png, when there was no data to export'
			});
		}
	}
};
